/** Asset materials and catalog files, from the API contract (`src/api/generated`). */

import type {
  FileOutOutput,
  FileStatusOutOutput,
  MaterialFileOutOutput,
  MaterialIn,
  MaterialOutOutput,
  MaterialSaveOutOutput,
} from '../generated/schemas';

export type { MaterialIn, MaterialPatchIn as MaterialPatch } from '../generated/schemas';

export type MaterialKind = MaterialOutOutput['kind'];
export type MaterialAudience = MaterialIn['audience'];
export type MaterialType = MaterialIn['material_type'];
/** pending, ready or unreadable (the contract types it as a string). */
export type TextStatus = FileStatusOutOutput['text_status'];

export const MATERIAL_TYPES: { value: MaterialType; label: string }[] = [
  { value: 'one_pager', label: 'One-pager' },
  { value: 'executive_deck', label: 'Executive deck' },
  { value: 'technical_deck', label: 'Technical deck' },
  { value: 'commercial_model', label: 'Commercial model' },
  { value: 'demo', label: 'Demo' },
  { value: 'case_study', label: 'Case study' },
  { value: 'architecture', label: 'Architecture' },
  { value: 'other', label: 'Other' },
];

export type MaterialFile = MaterialFileOutOutput;
/** One entry of `AssetOut.materials`, already filtered to what the caller may see. */
export type MaterialOut = MaterialOutOutput;
export type MaterialSaveOut = MaterialSaveOutOutput;
/** `POST /api/files`. */
export type CatalogFileOut = FileOutOutput;
/** One row of `GET /api/files/status`. */
export type FileStatusOut = FileStatusOutOutput;
